
<ngx-spinner bdColor = "rgba(16,16,16,0.8)" size = "medium" color = "#fffff" type = "ball-climbing-dot" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
<router-outlet></router-outlet> 



 

